/* eslint-disable @typescript-eslint/require-await */

import { PaymentOrderRedirectUrlQuery } from '@dreryk/egabinet-online-payments-integration-frontend-api';

import { performCqrsQueryGet } from '@dreryk/command-query-react-common';

export const performPaymentOrderRedirectUrlCqrsGet = async (onlinePaymentId: string): Promise<string> => {
   return performCqrsQueryGet<string>(
      () => {
         const query = new PaymentOrderRedirectUrlQuery();
         query.onlinePaymentId = onlinePaymentId;
         return query;
      },
      {
         retryOnError: true,
      }
   );
};
